import { Link, useNavigate } from 'react-router-dom';
import { getCategoryMetaByName, splitPostCategories } from '../blog/categories';
import { formatPostDate } from '../blog/dates';
import { getPostThumbnail, cloudinaryThumb } from '../blog/media';

export default function BlogCard({ post, onCategoryClick, canEdit = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/blog/${post.id}`);
  };

  const categoryNames = splitPostCategories(post.category);
  const rawThumbnail = getPostThumbnail(post);
  const thumbnailSrc = cloudinaryThumb(rawThumbnail, { width: 500 });
  const postDate = formatPostDate(post, '-');

  return (
    <div
      className="blog-card"
      onClick={handleClick}
    >
      <div className="blog-card-thumbnail-container">
        {thumbnailSrc ? (
          <img
            src={thumbnailSrc}
            srcSet={`${cloudinaryThumb(rawThumbnail, { width: 300 })} 300w, ${cloudinaryThumb(rawThumbnail, { width: 500 })} 500w, ${cloudinaryThumb(rawThumbnail, { width: 750 })} 750w`}
            sizes="(max-width: 768px) 100vw, 250px"
            width={250}
            height={200}
            alt={`Miniatura wpisu: ${post.title}`}
            className="blog-card-thumbnail"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="blog-card-thumbnail-placeholder">
            Brak miniatury
          </div>
        )}
      </div>
      <div className='blog-card-content'>
        <h4 className="blog-card-title">
          <Link
            to={`/blog/${post.id}`}
            className="blog-card-title-link"
            onClick={(event) => event.stopPropagation()}
          >
            {post.title}
          </Link>
        </h4>
        <p className="blog-card-meta">
          {post.author} &nbsp;&nbsp;&nbsp;&nbsp; {postDate} &nbsp;&nbsp;&nbsp;&nbsp; {post.reading_time}
        </p>
        <div className="blog-card-categories">
          {categoryNames.length > 0 ? (
            categoryNames.map((categoryName) => {
              const categoryMeta = getCategoryMetaByName(categoryName);
              const style = categoryMeta
                ? {
                    color: categoryMeta.color,
                    backgroundColor: categoryMeta.bgColor,
                    borderColor: categoryMeta.borderColor,
                  }
                : undefined;

              return (
                <button
                  key={`${post.id}-${categoryName}`}
                  type="button"
                  className="blog-card-category-badge"
                  style={style}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (onCategoryClick) {
                      onCategoryClick(categoryName);
                    }
                  }}
                >
                  {categoryMeta?.label || categoryName}
                </button>
              );
            })
          ) : (
            <span className="blog-card-category-badge blog-card-category-badge--empty">
              Bez kategorii
            </span>
          )}
        </div>
        <div className="blog-card-content-preview"></div>
        {canEdit && (
          <button
            className="button-default btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/edit/${post.id}`);
            }}
            style={{ marginTop: '0.5rem' }}
          >
            Edytuj
          </button>
        )}
      </div>
    </div>
  );
}
